import request from 'local_modules/request'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierTicketPage.setFetching(isFetching)

const fetchTickets = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.cashierTickets + `/${tool}`)
    .then(({ data }) => data)
    .then((tickets) => reducers.marketplace.cashierTicketPage.setTickets(tickets))
    .catch((error) => console.log(error))
}

const setTicket = (orderId) => {
  return request.post(constants.marketplace.cashierTicketsActivate + `/${orderId}`, {})
    .then(({ data }) => data)
}


export default {
  setFetching,
  fetchTickets,
  setTicket,
}
